<template>
  <div>
    <b-container>
      <b-row>
        <b-col cols="12">
          <img class="img-auto" src="../assets/logo-promart.png" alt="" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-nav vertical
            class="align-center">
            <b-nav-item v-for="(option, index) in menuOptions"
            :key="index" :to="{ name: option.name }" >
            {{ option.description }}
            </b-nav-item>
            <b-nav-item :to="{ name: 'OneTrack'}" >
             OneTrack
            </b-nav-item>
        
            
              <b-button
                class="float-left btn-transparent"
                v-b-toggle="'collapse-2'"
              >
                Reportes
                <span class="float-right"
                  ><font-awesome-icon icon="chevron-down"
                /></span>
              </b-button>
              <b-collapse id="collapse-2">
                <b-card class="bg-darkblack">
                  <ul class="list-style-none bg-darkblack color-white d-flex">
                   <b-nav-item v-if="reporteTienda" class="color-white nav-link" :to="{ name: 'ReportesServicios'}"
                    >
                   Reportes Servicios 
                  </b-nav-item>
                  <b-nav-item v-if="reporteVtex" class="color-white nav-link" :to="{ name: 'ReportesVtex'}" >
                   Reportes Vtex 
                  </b-nav-item> 
                   <b-nav-item  v-if="reporteProyectos"  class="color-white nav-link" :to="{ name: 'ReportesProyectos'}" >
                   Reportes Proyectos 
                  </b-nav-item>  
                  </ul>
                </b-card>
              </b-collapse>
          </b-nav>
          
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "SideBar",
  computed: {
    ...mapState("module", ["username", "options"]),

    menuOptions() {
      let filterMenu = this.options.filter(
        (item) => item.nivelAnidamiento == 1&&item.id!=28
      );
      return filterMenu;
    },
    subMenuOptions() {
      let filterMenu = this.options.filter(
        (item) => item.nivelAnidamiento == 2 && item.posicion.startsWith("06")
      );
      return filterMenu;
    },
    reporteTienda() {
      
      return this.options.some((m) => m.id === 26||m.id===27);
    },
     reporteVtex() {
      
      return this.options.some((m) => m.id ===31);
    },
    reporteProyectos() {
      
      return this.options.some((m) => m.id ===40);
    }
  },
};
</script>
<style scoped>
.card-body {
  padding: 0;
}
.d-flex {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  flex-direction: column !important;
}
.padding-user {
  padding: 0.5rem 1rem;
}
.float-right {
  float: right;
  color: black;
}
.btn-transparent {
  background: transparent !important;
  border: none !important;
}
.btn-transparent:active {
  background: transparent !important;
}
.btn-transparent:focus {
  background: transparent !important;
}
.bg-darkblack {
  background: transparent !important;
}
.width-auto {
  width: 100%;
}
.router-link-active {
  color: rgb(254, 123, 1) !important;
  border-bottom: 1px solid rgb(254, 123, 1);
  font-weight: bold;
}
.color-white {
  color: white;
}

.MuiDrawer-paper {
  top: 0;
  flex: 1 0 auto;
  height: 100%;
  display: flex;
  outline: 0;
  z-index: 15;
  position: fixed;
  overflow-y: auto;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
  width: 240px;
  transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
  white-space: nowrap;
}
.makeStyles-toolbar-9 {
  display: flex;
  padding: 0px 8px;
  min-height: 68px;
  align-items: center;
  justify-content: center;
}

.bg-black {
  background: #383838;
}
.img-auto {
  width: 100%;
  height: auto;
  padding: 11px;
}
.display-inline-flex {
  display: inline-flex;
}
.padding-two-left {
  padding-left: 5px;
}
.float-left {
  text-align: left;
}
.nav-link {
  color: black;
  padding: 0.9rem 1rem;
}
.d-flex {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  flex-direction: column !important;
}
.list-style-none {
  list-style: none;
  margin-left: 0 !important;
  padding-left: 0 !important;
}
.btn-transparent {
  background: transparent !important;
  border: none !important;
  color: black !important;
  padding: 0.9rem 1rem;
}
</style>
